<template>
  <li class="bundle shadow-md p-4 overflow-hidden rounded-lg place-content-center">
    <a
      class="flex flex-wrap flex-row sm:flex-row md:flex-col lg:flex-row items-center text-decoration-none justify-center md:justify-center lg:justify-start text-center md:text-center lg:text-left md:space-x-0 md:space-y-2 lg:space-x-2 lg:space-y-0"
    >
      <div class="flex items-center lg:justify-start text-left">
        <v-bundle-icon class="fill-current text-white mr-4 h-9 w-7" />
      </div>
      <div
        class="flex flex-col flex-grow text-white pr-2 w-full lg:w-1/3 text-center lg:text-left"
        @click.prevent="goToBundleProducts()"
      >
        <strong class="underline mb-2 cursor-pointer" :class="'btn_bundel_st_' + bundle.name">
          Bestelpakket : {{ bundle.name }}
        </strong>
        <strong class="text-base text-white">{{ bundle.description }}</strong>
      </div>
      <div class="grid mx-auto mt-2 md:mt-0">
        <a
          class="ml-auto text-white p-3 rounded-button cursor-pointer rounded-lg"
          @click.prevent="addAllBundleProducts"
        >
          Bestellen
        </a>
      </div>
    </a>
  </li>
</template>

<script>
import VBundleIcon from 'icons/Layers';
import { addIllnessBundleToShoppingCart, shoppingCart$ } from '@/services';
import router from '@/router';
import { useStore } from 'vuex';
import { ref } from 'vue';

export default {
  name: 'Bundle',
  components: {
    VBundleIcon
  },
  props: {
    bundle: {
      type: Object,
      required: true
    }
  },
  setup() {
    const store = useStore();
    const shoppingCart = ref(null);

    const setCartOpenStatus = (value) => store.commit('cart/setCartOpenStatus', value);

    shoppingCart$.subscribe((value) => {
      shoppingCart.value = value;
    });

    return {
      shoppingCart,
      setCartOpenStatus
    };
  },
  computed: {},
  methods: {
    /**
     * @function addAllBundleProducts
     * @description add all the base products to the cart
     */
    addAllBundleProducts() {
      if (this.isAuthorizationSignedPage()) {
        addIllnessBundleToShoppingCart(this.shoppingCart, this.bundle.illnessBundleId).then((response) => {
          this.setSignatureSaved(false);
          this.shoppingCart.items.forEach((item) => {
            this.$gtm.trackEvent({
              event: 'ButtonClick',
              event_category: 'Product cart',
              event_action: 'Bestellen',
              event_label: `${item.productId} ${item.productTitle}`,
              event_value: String(item.quantity)
            });
          });
        });
        router.push('/bestellijst');
      } else {
        addIllnessBundleToShoppingCart(this.shoppingCart, this.bundle.illnessBundleId);
        this.showAlert();
      }
    },
    // Function to show an alert message
    showAlert() {
      this.$emitter.emit('alert', {
        message: 'Alle producten zijn toegevoegd aan de bestellijst.'
      });
    },
    // Function to navigate BundleProducts page
    goToBundleProducts() {
      router.push('/catalog/bundel/' + this.bundle.illnessBundleId);
    },
    isAuthorizationSignedPage() {
      return router.currentRoute.value.name === 'bundles';
    }
  }
};
</script>

<style lang="scss" scoped>
.bundle {
  background: $dark-violet;
}
.rounded-button {
  background-color: color.adjust($dark-violet, $lightness: -10%);
}
</style>
